import * as React from "react";

function SvgMoosend(props, ref) {
  return (
    <svg
      id="Moosend_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 215.6 200"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Moosend_svg__st0{fill:#fff}.Moosend_svg__st1{fill:#394257}"}
      </style>
      <path
        className="Moosend_svg__st0"
        d="M175.2 125.5c0 11.7-9.5 21.2-21.2 21.2H63.5c-11.7 0-21.2-9.5-21.2-21.2V37.4c0-11.7 9.5-21.2 21.2-21.2H154c11.7 0 21.2 9.5 21.2 21.2v88.1z"
      />
      <path
        className="Moosend_svg__st1"
        d="M65.7 12.8s8.9-29 20 .3c-19.5-.3-20-.3-20-.3zM131.3 12.8s8.9-29 20 .3c-19.5-.3-20-.3-20-.3z"
      />
      <path
        className="Moosend_svg__st0"
        d="M149 172.4c.6 1.8-.4 3.7-2.2 4.3l-61.4 19.5c-1.8.6-3.7-.4-4.3-2.2l-12.8-40.4c-.6-1.8.4-3.7 2.2-4.3l61.4-19.5c1.8-.6 3.7.4 4.3 2.2l12.8 40.4z"
      />
      <path
        className="Moosend_svg__st1"
        d="M84.7 200c-2.8 0-5.3-1.8-6.1-4.5l-12.8-40.4c-1.1-3.4.8-7 4.2-8.1l61.4-19.5c3.3-1 7 .9 8.1 4.2l12.8 40.4c1.1 3.4-.8 7-4.2 8.1l-61.4 19.5c-.7.2-1.3.3-2 .3zm48.5-66.7l-61.5 19.5c-.2.1-.3.3-.2.5l12.8 40.4c.1.3.3.3.5.2l61.4-19.5c.2-.1.3-.3.2-.5l-12.8-40.4c-.1-.1-.2-.2-.4-.2z"
      />
      <path
        className="Moosend_svg__st0"
        d="M70.4 150.2c-1.5.7-2.3 2.4-1.8 4.1l12.8 40.4c.2.6.6 1.2 1.1 1.6l16.7-32.4-28.8-13.7z"
      />
      <path
        className="Moosend_svg__st1"
        d="M84.4 199.2l-3.8-.7c-1-.8-1.7-1.8-2.1-3l-12.8-40.4c-1-3 .5-6.3 3.4-7.7l1.3-.6 32.9 15.6-18.9 36.8zm-12.6-45L82.9 189l12.2-23.8-23.3-11z"
      />
      <path
        className="Moosend_svg__st0"
        d="M149.2 175.3c.3-.7.3-1.5.1-2.2L136.5 133c-.6-1.8-2.4-2.5-4.2-2l-.4.1-16.2 27.3 33.5 16.9z"
      />
      <path
        className="Moosend_svg__st1"
        d="M149.1 178.6l-37.7-19 18.5-31 1.5-.5c3.5-1.1 7 .7 8 3.9l12.8 40.1c.4 1.4.4 2.8-.1 4.2l-3 2.3zM120 157.1l25.1 12.7-11.4-35.8-13.7 23.1z"
      />
      <path
        className="Moosend_svg__st0"
        d="M134.6 130.6c-.7-.3-1.6-.4-2.4-.2L70.8 150c-.9.3-1.7 1-2 1.8l42.2 21.3 23.6-42.5z"
      />
      <path
        className="Moosend_svg__st1"
        d="M112.3 177.2l-46.5-23.5.2-3.1c.7-1.7 2.2-2.9 3.9-3.5l61.4-19.5c1.5-.5 3.1-.4 4.6.3l3 1.4-26.6 47.9zm-36.9-25.5l34.4 17.4 19-34.3-53.4 16.9z"
      />
      <path
        className="Moosend_svg__st1"
        d="M108.2 93.1c-31 0-57.4 8.1-70.7 20.7.1 16.4 13 33.7 29.4 33.7h82.6c16.4 0 29-17.6 29.1-34-13.3-12.6-39.5-20.4-70.4-20.4zM165.3 15.7l50.3 29.1s-22.4 17.9-40.3 5.1c-1-.7.5-21.1-.4-22l-9.6-12.2z"
      />
      <g>
        <path
          className="Moosend_svg__st1"
          d="M50.3 15.7L0 44.8s22.4 17.9 40.3 5.1c1-.7-.5-21.1.4-22l9.6-12.2z"
        />
      </g>
      <g>
        <path
          d="M108.2 99.2c-31 0-56.5 8.4-69.8 20.3.1 15.3 12.1 28.1 28.5 28.1h82.6c16.4 0 28.6-12.2 28.7-27.5-13.3-11.9-39.1-20.9-70-20.9z"
          fill="#e16053"
        />
      </g>
      <g>
        <path
          className="Moosend_svg__st1"
          d="M102.5 69.4c-.9 3.5-3.3 5.9-5.5 5.3-2.2-.5-3.2-3.8-2.3-7.3.9-3.5 3.3-5.9 5.5-5.3 2.1.5 3.2 3.8 2.3 7.3z"
        />
      </g>
      <g>
        <path
          className="Moosend_svg__st1"
          d="M122.7 67.3c1 3.5.1 6.7-2.1 7.4-2.1.6-4.7-1.7-5.7-5.1-1-3.4 0-6.7 2.1-7.4 2.2-.7 4.7 1.6 5.7 5.1z"
        />
      </g>
      <g>
        <path
          className="Moosend_svg__st1"
          d="M86 124.7c2.9 5 2.8 10.5-.3 12.3-3.1 1.8-8-.8-10.9-5.7-2.9-5-2.8-10.5.3-12.3 3.1-1.9 8 .7 10.9 5.7z"
        />
      </g>
      <g>
        <path
          className="Moosend_svg__st1"
          d="M133.8 125c-2.9 5-2.8 10.5.3 12.3 3.1 1.8 8-.8 10.9-5.7 2.9-5 2.8-10.5-.3-12.3-3.2-1.9-8 .7-10.9 5.7z"
        />
      </g>
      <g>
        <path
          className="Moosend_svg__st1"
          d="M178.5 40.4c0-16.4-13.3-29.8-29.8-29.8H66.9C50.4 10.6 37 23.7 37 40.1v82.6c0 16.4 13.4 30.3 29.8 30.3h82.6c16.4 0 29.8-13.6 29.8-30l-.7-82.6zm-5.2 84.2c0 12.3-9.9 22.2-22.2 22.2H65.4c-12.3 0-22.2-9.9-22.2-22.2V39c0-12.3 9.9-22.2 22.2-22.2H151c12.3 0 22.2 9.9 22.2 22.2v85.6z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgMoosend);
